<div class="h-100">
  <div class="p-3 bg-white shadow-sm rounded d-flex flex-column h-100">
    <div class="text-bold align-self-sm-center">
      <ng-icon name="lucideSquare" class="text-secondary me-2"></ng-icon>
      {{ request.workshop.title }}
    </div>
    <div
      class="ms-4 ms-sm-2 my-1 my-sm-0 align-self-sm-center"
      *ngIf="request.workshop.holdingDateJalali"
    >
      {{ request.workshop.holdingDateJalali }}
    </div>
    <div
      class="ms-4 ms-sm-2 my-1 my-sm-0 align-self-sm-center"
      *ngIf="request.workshop.holdingTypeTitle"
    >
      {{ request.workshop.holdingTypeTitle }}
    </div>
    <div
      class="ms-4 ms-sm-2 my-1 my-sm-0 align-self-sm-center"
      *ngIf="request.registrationDateJalali"
    >
      {{ requestDateLabel }}: {{ request.registrationDateJalali }}
    </div>
    <div
      class="p-1 rounded ms-4 my-1 my-sm-0 text-center text-sm-center ms-auto"
    ></div>
    <div class="d-flex">
      <div *ngIf="request.status === 1">
        <ng-icon name="lucideLoader2" class="text-warning"></ng-icon>
      </div>
      <div *ngIf="request.status === 2">
        <ng-icon name="lucideCheck" class="text-success"></ng-icon>
      </div>
      <div *ngIf="request.status === 3">
        <ng-icon name="lucideBan" class="text-danger"></ng-icon>
      </div>
      <div *ngIf="request.status === 4">
        <ng-icon name="lucideHourglass" class="text-danger"></ng-icon>
      </div>
      <div class="ms-2" style="width: 60px">{{ request.statusTitle }}</div>
    </div>
  </div>
</div>
